<template>
    <div>
        <div
            v-if="!config.hasCertificate"
            class="kgr-inputGroup"
            :class="{ 'with-errors': error.forField('file') }"
        >
            <div class="kgr-inputGroup__label ui-droppable">
                {{ $t('Zertifikat im p12-Format') }}
            </div>
            <div>
                <div class="kgr-row">
                    <kgr-file-chooser @change="onCertificateChange($event)" />
                </div>
                <kgr-button
                    v-if="certificateFile"
                    :value="$t('Zertifikat hochladen')"
                    :pending="pendingUpload"
                    type="blue"
                    @click="uploadCertificate()"
                />
            </div>

            <div
                v-if="error.forField('file')"
                class="kgr-inputGroup__text kgr-inputGroup__text--error"
            >
                {{ error.messageForField('file') }}
            </div>
        </div>

        <div
            v-if="config.hasCertificate"
            class="kgr-inputGroup"
        >
            <div class="kgr-inputGroup__label">
                {{ $t('Zertifikat vorhanden') }}
            </div>
            <kgr-button
                v-if="config.hasCertificate && !certificateFile"
                type="red"
                :value="$t('Zertifikat löschen')"
                @click="deleteCertificate()"
            />
        </div>
    </div>
</template>

<script>
import Error from '../../../js/model/Error';
import FederationIsbjConfig from '../../../js/dto/isbj/FederationIsbjConfig';
import FileChooser from '../../common/file/FileChooser';
import IsbjCertificateRepository from '../../../js/repository/IsbjCertificateRepository';
import KgrButton from '../../common/form/button/KgrButton';

export default {
    components: {
        'kgr-file-chooser': FileChooser,
        'kgr-button': KgrButton,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
        config: {
            type: FederationIsbjConfig,
            required: true,
        },
    },
    data() {
        return {
            certificateFile: null,
            error: new Error(),
            pendingUpload: false,
        };
    },
    methods: {
        deleteCertificate() {
            showConfirm(this.$t('confirm'), this.$t('Soll das Zertifikat wirklich gelöscht werden?'), () => {
                IsbjCertificateRepository
                    .remove(this.federationId)
                    .then(() => {
                        this.error = new Error();
                        this.config.hasCertificate = false;

                        this.$forceUpdate();
                        this.$notify.success('Das Zertifikat wurde erfolgreich gelöscht.');
                    })
                    .catch((error) => this.handleError(error));

                this.certificateFile = null;
            }, 'Ok');
        },
        onCertificateChange(certificateFile) {
            this.certificateFile = certificateFile;
        },
        uploadCertificate() {
            if (!this.certificateFile) {
                return;
            }

            this.pendingUpload = true;
            IsbjCertificateRepository
                .update(this.federationId, this.certificateFile)
                .then(() => {
                    this.error = new Error();
                    this.config.hasCertificate = true;
                    this.certificateFile = null;

                    this.$forceUpdate();
                    this.$notify.success('Das Zertifikat wurde erfolgreich hochgeladen.');
                })
                .catch((error) => this.handleError(error))
                .finally(() => this.pendingUpload = false);
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
};
</script>
